import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { Dealer } from "src/app/models/dealer/dealer";
import { DealerApsFordDetailAttributes } from "src/app/models/dealer/dealer-aps-ford-detail-attributes";
import { DealerCountryDto } from "src/app/models/dealer/dealer-country-dto";
import { DealerSeller } from "src/app/models/dealer/dealer-seller";
import { environment } from "src/environments/environment";
import { ConstantsFordProtect } from "src/app/models/constants/constants-ford-protect";
import { SellersRequest } from "src/app/models/dealer/sellers-request";

@Injectable({
  providedIn: 'root'
})
export class DealerService {

  private apiUrl = environment.apiUrl;
  private dealerCountry: DealerCountryDto;

  constructor(private httpClient: HttpClient) {
  }

  getDealer(dealer: Dealer): Observable<Dealer> {
    return this.httpClient.get<Dealer>(`${this.apiUrl}/api/dealers/${dealer.geoSalesCode}/${dealer.pandAC}`)
      .pipe(
        map((response: Dealer) => {
          return response;
        })
      );
  }

  getDealerWithCuitFromBigQuery(dealer: Dealer): Observable<Dealer> {
    return this.httpClient.get<Dealer>(
      `${this.apiUrl}/api/dealers/${dealer.geoSalesCode}/${dealer.pandAC}`,
      { params: { includeCuitFromBigQuery: 'true' } }
    );
  }

  getDealerSignature(geoSalesCode: string, pandAC: string): Observable<Dealer> {
    return this.httpClient.get<Dealer>(`${this.apiUrl}/api/dealers/signature/${geoSalesCode}/${pandAC}`)
      .pipe(
        map((response: Dealer) => {
          return response;
        })
      );
  }

  getDealerSeller(dealerSeller: DealerSeller): Observable<DealerSeller> {

    const sellersRequest = new SellersRequest();
    sellersRequest.sellerCode = dealerSeller.sellerCode;

    return this.httpClient.post<DealerSeller>(`${this.apiUrl}/api/v2/sellers`, sellersRequest)
      .pipe(
        map((response: DealerSeller) => {
          return response;
        })
      );
  }

  getDealerSellerSignature(sellerK: number): Observable<DealerSeller> {
    return this.httpClient.get<DealerSeller>(`${this.apiUrl}/api/sellers/seller-id/${sellerK}`)
      .pipe(
        map((response: DealerSeller) => {
          return response;
        })
      );
  }

  getDealerName(dealerSeller: DealerSeller): Observable<DealerApsFordDetailAttributes> {
    const userName = dealerSeller.name;
    const entityName = "TMAC";
    return this.httpClient.get<DealerApsFordDetailAttributes>(`${this.apiUrl}/api/dealers/fordaps?userName=${userName}&entityName=${entityName}`)
      .pipe(
        map((response: DealerApsFordDetailAttributes) => {
          return response;
        })
      );
  }

  getDealerNameAndCode(): Observable<DealerApsFordDetailAttributes> {
    const entityName = ConstantsFordProtect.TMAC;
    return this.httpClient.get<DealerApsFordDetailAttributes>(`${this.apiUrl}/api/dealers/fordaps?entityName=${entityName}`)
      .pipe(
        map((response: DealerApsFordDetailAttributes) => {
          return response;
        })
      );
  }
  
  getDealerCountry(): Observable<DealerCountryDto> {
    const entityName = ConstantsFordProtect.TMAC;
    return this.httpClient.get<DealerCountryDto>(`${this.apiUrl}/api/dealers/dealerCountry?&entityName=${entityName}`)
      .pipe(
        map((response: DealerCountryDto) => {
          return response;
        })
      );
  }
}